// extracted by mini-css-extract-plugin
export default {"rhsGam":"ArticlePageRhsGam_rhsGam__NGHVf"};